module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/tuxedo-571df59da4b7beedec453c5d6b417a2e.jpg";